import { render, staticRenderFns } from "./layout-header.vue?vue&type=template&id=23da2d9d&scoped=true&"
import script from "./layout-header.vue?vue&type=script&lang=js&"
export * from "./layout-header.vue?vue&type=script&lang=js&"
import style0 from "./layout-header.vue?vue&type=style&index=0&id=23da2d9d&lang=stylus&scoped=true&"
import style1 from "./layout-header.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da2d9d",
  null
  
)

component.options.__file = "layout-header.vue"
export default component.exports